import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalWorkingGroupsRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/working-groups",
  component: lazyRouteComponent(
    () => import("./working-groups.page.js"),
    "PortalWorkingGroupsPage",
  ),
});
